module.exports = __webpack_public_path__ + "img/dd505e1.png";